var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9658 0.78362C16.5329 -0.542844 18.9122 0.573688 18.8934 2.62673L18.729 20.6043C18.709 22.8138 15.9426 23.8913 14.4951 22.1543L10.2019 16.9996C10.0191 16.7803 9.7507 16.6543 9.46523 16.6539L2.75689 16.6459C0.49572 16.6425 -0.443296 13.8261 1.24327 12.3988L14.9658 0.78362ZM17.4813 2.61335C17.4895 1.76906 16.5228 1.31541 15.8779 1.86089L2.15616 13.4765C1.42229 14.0972 1.87693 15.2328 2.75856 15.2342L9.46691 15.2422C10.1701 15.2436 10.8356 15.5559 11.2869 16.0962L15.5801 21.2509C16.1445 21.9281 17.3085 21.5521 17.317 20.591L17.4813 2.61335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionIcon);
export default __webpack_public_path__ + "static/media/directionIcon.66a4228ef389776345fee0408f9ada2c.svg";
export { ForwardRef as ReactComponent };